import { render, staticRenderFns } from "./UserFooter.vue?vue&type=template&id=15375e18&scoped=true&"
import script from "./UserFooter.vue?vue&type=script&lang=js&"
export * from "./UserFooter.vue?vue&type=script&lang=js&"
import style0 from "./UserFooter.vue?vue&type=style&index=0&id=15375e18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15375e18",
  null
  
)

export default component.exports